import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import paginationFactory from "react-bootstrap-table2-paginator";
// import * as columnFormatter from "../jobgroups/formatters";
import { Dropdown } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import {
  TextField,
  Divider,
  Grid,
  Paper,
  Snackbar,
  Typography,
  Modal,
  Button,
} from "@material-ui/core";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, sortCaret } from "../../_metronic/_helpers";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Dialog } from "@material-ui/core";
import { DialogActions } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import { DialogContentText } from "@material-ui/core";
import { DialogTitle } from "@material-ui/core";
import { Slide } from "@material-ui/core";
import { connect, shallowEqual, useSelector } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
// import * as provinces from "./_redux/provincesRedux";
// import { getAllProvinces } from "./_redux/provincesCrud";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Input,
  Select,
  DatePickerField,
} from "../../_metronic/_partials/controls";
import {
  createFavPassenger,
  getAllFavPassengers,
  updateFavPassenger,
  deleteFavPassenger,
} from "../modules/Account/_redux/passengers/passengersCrud";
import * as redux from "../modules/Account/_redux/passengers/passengersActions";
import { NavBar } from "../modules/Account/pages/Navbar";
import Alert from "@material-ui/lab/Alert";

// Validation schema

const persianREGEX = /^[\u0600-\u06FF]+$/;

const CustomerEditSchema = Yup.object().shape({
  passengerFirstName: Yup.string("فرمت وارد شده اشتباه است")

    .min(3, "حداقل کارکتر:3")
    .max(30, "حداکثر کارکتر:30")
    .required("نام الزامی است"),
  passengerLastName: Yup.string("فرمت وارد شده اشتباه است")

    .min(3, "حداقل کارکتر:3")
    .max(30, "حداکثر کارکتر:30")
    .required("نام خانوادگی الزامی است"),
  passengerFirstNationalCode: Yup.number("فرمت وارد شده اشتباه است")
    .min(10, "کدملی باید 10 رقم باشد")
    // .max(10, "کدملی باید 10 رقم باشد")
    .required("کد ملی الزامی است"),
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function FavPassengers(props) {
  const [open, setOpen] = React.useState(false);
  const [editOpen, setEditOpen] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const [current, setCurrent] = React.useState({});
  const [loadState, setLoadState] = React.useState(false);

  React.useEffect(() => {
    getAllFavPassengers(user).then((res) => {
      props.getAllPassengers(res.data.Data);
      setLoadState(true);
    });
  }, []);

  const handleClickOpen = () => {
    setCurrent({});
    setEditMode(false);
    setEditOpen(true);
  };
  const handleEditClickOpen = () => {
    setEditMode(true);
    setEditOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditClose = () => {
    setCurrent({});
    setEditOpen(false);
    setEditMode(false);
  };

  const { user } = useSelector((state) => state.auth);

  let { state } = useSelector(
    (state) => ({
      state: state.passengers,
    }),
    shallowEqual
  );

  const pagination = paginationFactory({
    page: 1,
  });

  console.log("state", state);

  // if (!state.isProvincesLoaded) {
  //   getAllProvinces(user).then((res) => {
  //     props.getAllProvinces(res.data.Result);
  //   });
  // }

  const { SearchBar, ClearSearchButton } = Search;
  const selectOptions = [
    { value: true, label: "فعال" },
    { value: false, label: "غیر فعال" },
  ];
  const columns = [
    {
      dataField: "id",
      text: "شناسه",
      sort: true,
      sortCaret: sortCaret,
      // filter: textFilter()
    },
    {
      dataField: "passengerFirstName",
      text: "نام",
      sort: true,
      // filter: textFilter()
      sortCaret: sortCaret,
    },
    {
      dataField: "passengerLastName",
      text: "نام خانوادگی",
      sort: true,
      // filter: textFilter()
      sortCaret: sortCaret,
    },
    {
      dataField: "passengerFirstNationalCode",
      text: "کد ملی",
      sort: true,
      // filter: textFilter()
      sortCaret: sortCaret,
    },
    {
      dataField: "action",
      text: "عملیات",
      sort: false,
      sortCaret: sortCaret,

      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <Dropdown size={"sm"} className="dropdown-inline" alignRight>
              <Dropdown.Toggle size={"sm"} variant="light" id="dropdown-basic">
                <span style={{ marginLeft: 5 }}> عملیات</span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    setCurrent({
                      id: row.id,
                      passengerFirstName: row.passengerFirstName,
                      passengerLastName: row.passengerLastName,
                      passengerFirstNationalCode:
                        row.passengerFirstNationalCode,
                    });
                    handleEditClickOpen();
                  }}
                >
                  <i
                    className="fa fa-edit"
                    style={{ marginLeft: 10, fontSize: 11 }}
                  ></i>
                  ویرایش
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    setOpen(true);
                    setCurrent(row);
                  }}
                >
                  <i
                    className="fa fa-trash"
                    style={{ marginLeft: 10, fontSize: 11 }}
                  ></i>
                  حذف
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </>
        );
      },
      sort: true,
    },
  ];

  return (
    <>
      <Snackbar
        open={state.snackOpen}
        autoHideDuration={8000}
        onClose={() => props.hideMessage()}
      >
        <Alert onClose={() => props.hideMessage()} severity={state.snackType}>
          {state.snackMessage}
        </Alert>
      </Snackbar>
      <Grid container spacing={3}>
        <Grid item sm={12} className={"mt-5"}>
          <NavBar className="gutter-b" />
        </Grid>
        {loadState ? (
          <Grid item sm={12} className={"mt-5"}>
            <Grid container spacing={3}>
              <Card>
                <CardHeader title="لیست مسافرها">
                  <CardHeaderToolbar>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleClickOpen}
                    >
                      مسافر جدید
                      <i className="fa fa-plus" style={{ marginRight: 5 }}></i>
                    </button>
                  </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                  <ToolkitProvider
                    keyField="id"
                    data={state.passengers.length != 0 ? state.passengers : []}
                    columns={columns}
                  >
                    {(props) => (
                      <div>
                        <BootstrapTable
                          filter={filterFactory()}
                          {...props.baseProps}
                          bordered={false}
                          bootstrap4
                          pagination={pagination}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
              <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle id="alert-dialog-slide-title">
                  {"آیا واقعا قصد حذف این مسافر را دارید ؟"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>انصراف</Button>
                  <Button
                    onClick={() => {
                      deleteFavPassenger(user, current.id).then((res) => {
                        getAllFavPassengers((res) =>
                          props.getAllPassengers(res.data.Data)
                        );
                      });
                      setOpen(false);
                    }}
                    className="btn btn-danger"
                    color="danger"
                  >
                    حذف
                  </Button>
                </DialogActions>
              </Dialog>

              <Formik
                enableReinitialize={true}
                initialValues={current}
                validationSchema={CustomerEditSchema}
                onSubmit={(values) => {
                  if (!editMode) {
                    CustomerEditSchema.isValid(values).then((res, pes, ses) => {
                      if (res) {
                        createFavPassenger(user, values).then((res) => {
                          getAllFavPassengers(user).then((res) => {
                            props.getAllPassengers(res.data.Data);
                          });
                          setEditOpen(false);
                        });
                        return true;
                      } else {
                        alert("مقادیر ورودی را چک کنید");
                        return false;
                      }
                    });
                  } else if (editMode) {
                    CustomerEditSchema.isValid(values).then((res) => {
                      if (res) {
                        updateFavPassenger(user, current.id, values)
                          .then((res) =>
                            getAllFavPassengers((res) =>
                              props.getAllPassengers(res.data.Data)
                            )
                          )
                          .catch((err) => console.log(err));
                        setCurrent({});
                        setEditOpen(false);
                        setEditMode(false);
                      } else {
                        alert("مقادیر ورودی را چک کنید");
                        return false;
                      }
                    });
                  }
                }}
              >
                {({ handleSubmit, touched, errors }) => (
                  <>
                    <Dialog
                      onClose={handleClose}
                      aria-labelledby="customized-dialog-title"
                      open={editOpen}
                    >
                      <DialogTitle>
                        <div>{editMode ? "ویرایش مسافر" : "اضافه مسافر"}</div>
                      </DialogTitle>
                      <DialogContent>
                        <div>
                          <Form className="form form-label-right">
                            <div className="form-group row">
                              <div className="col-lg-4">
                                <Field
                                  name="passengerFirstName"
                                  component={Input}
                                  placeholder="نام"
                                  label="نام"
                                />
                                {touched.passengerFirstName ? (
                                  <div>{touched.passengerFirstName}</div>
                                ) : null}
                              </div>
                              <div className="col-lg-4">
                                <Field
                                  name="passengerLastName"
                                  component={Input}
                                  placeholder="نام خانوادگی"
                                  label="نام خانوادگی"
                                />
                                {touched.passengerLastName ? (
                                  <div>{touched.passengerLastName}</div>
                                ) : null}
                              </div>
                              <div className="col-lg-4">
                                <Field
                                  name="passengerFirstNationalCode"
                                  component={Input}
                                  placeholder="کد ملی"
                                  label="کد ملی"
                                />
                                {touched.passengerFirstNationalCode ? (
                                  <div>
                                    {touched.passengerFirstNationalCode}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </Form>
                        </div>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant="secondary"
                          onClick={() => handleEditClose()}
                        >
                          <div>انصراف</div>
                        </Button>
                        <Button
                          className="btn btn-primary"
                          variant="primary"
                          onClick={() => handleSubmit()}
                        >
                          <div>ثبت</div>
                        </Button>
                      </DialogActions>
                    </Dialog>
                    {/* <Modal show={editOpen} onHide={handleEditClose}>
              <Modal.Header closeButton>
                <Modal.Title>
                  <div>افزودن مسافر</div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <Form className="form form-label-right">
                    <div className="form-group row">
                      <div className="col-lg-4">
                        <Field
                          name="passengerFirstName"
                          component={Input}
                          placeholder="نام"
                          label="نام"
                        />
                      </div>
                      <div className="col-lg-4">
                        <Field
                          name="passengerLastName"
                          component={Input}
                          placeholder="نام خانوادگی"
                          label="نام خانوادگی"
                        />
                      </div>
                      <div className="col-lg-4">
                        <Field
                          name="passengerFirstNationalCode"
                          component={Input}
                          placeholder="کد ملی"
                          label="کد ملی"
                        />
                      </div>
                    </div>
                  </Form>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => handleEditClose()}>
                  <div>انصراف</div>
                </Button>
                <Button
                  className="btn btn-primary"
                  variant="primary"
                  onClick={() => handleSubmit()}
                >
                  <div>ثبت</div>
                </Button>
              </Modal.Footer>
            </Modal> */}
                  </>
                )}
              </Formik>
            </Grid>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            className={"mt-4"}
            style={{
              height: "4rem",
              paddingBlock: "15px",
              backgroundColor: "white",
            }}
          >
            <b>در حال دریافت اطلاعات</b>
          </Grid>
        )}
      </Grid>
    </>
  );
}
export default injectIntl(connect(null, redux.actions)(FavPassengers));
